import PublicLayout from "../components/PublicLayout";

export default function AboutPage() {
  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto px-4 py-12" data-testid="about-page">
        <div className="hairline-accent pt-3 mb-8">
          <p className="overline">Institucional</p>
          <h1 className="font-serif-display text-5xl font-bold leading-tight mt-2">Sobre o Chiquinho</h1>
          <p className="font-body text-xl text-zinc-700 mt-3">Jornalismo independente do Acre, com profundidade e responsabilidade.</p>
        </div>

        <figure className="mb-8">
          <img src="https://images.pexels.com/photos/32957317/pexels-photo-32957317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="Redação" className="w-full" />
          <figcaption className="font-sans-ui text-xs text-zinc-500 mt-2">Equipe editorial em ação · Foto de arquivo</figcaption>
        </figure>

        <div className="prose-article drop-cap font-body text-lg max-w-none">
          <p>O <strong>Chiquinho o 01 do Acre</strong> nasceu da convicção de que o estado merece um jornalismo digital à altura de sua complexidade. Em um mundo de informações fragmentadas, oferecemos contexto, rigor e a profundidade que só a tradição editorial pode entregar.</p>
          <p>Nossa cobertura abrange política, economia, cultura, esporte, saúde e meio ambiente — sempre com foco no que importa para o Acre e para o Brasil. Acreditamos no jornalismo de fato, no debate plural e na transparência absoluta.</p>
          <h2>Nossa missão</h2>
          <p>Informar com precisão, analisar com profundidade e formar opinião com responsabilidade. Não somos apenas mais um portal: somos o jornal de referência do Acre.</p>
          <h2>Princípios editoriais</h2>
          <ul>
            <li>Apuração rigorosa e checagem múltipla de fatos.</li>
            <li>Transparência sobre fontes e métodos.</li>
            <li>Pluralidade de vozes e debate qualificado.</li>
            <li>Independência editorial em relação a interesses políticos e econômicos.</li>
          </ul>
          <h2>Nossa equipe</h2>
          <p>Reunimos jornalistas experientes, editores premiados e colunistas de referência. Conheça os autores na seção dedicada a cada perfil.</p>
        </div>
      </div>
    </PublicLayout>
  );
}
